<template>
  <PgyCommonSdk
    v-if="showPgy"
    :options="options"
    :swimlane="testSwimLane"
    :ad-type="adType"
    :pos-id="posId"
    :utm_source="utmSource"
    :env="runtime"
    :pgy-ssr-response="pgySsrResponse"
    @update:visible="onUpdateVisible"
    @adClick="onAdClick"
    @custom-event="onCustomEvent"
    @refresh-data="onRefreshData"
  />
</template>

<script>
import { PgyCommonSdk } from '@fdfe/marketing-sdk/src/lib/index';
import { runtime, Runtime, env } from '@/common';

export default {
  name: 'CommonPgy',
  components: {
    PgyCommonSdk,
  },
  props: {
    posId: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const getRuntime = runtime > 2 ? 'test' : Runtime[runtime].toLocaleLowerCase();
    return {
      adType: 'SSR_SSR',
      utmSource: env.utmSource,
      runtime: getRuntime,
      testSwimLane: '48218-kaacb',
    };
  },
  computed: {
    pgySsrResponse() {
      return env?.pgyData?.[this.posId];
    },
    showPgy() {
      return env?.pgyDataReady;
    },
  },
  methods: {
    onUpdateVisible(val) {
      this.$emit('update:visible', val);
    },
    onAdClick(val) {
      this.$emit('adClick', val);
    },
    onCustomEvent(val) {
      this.$emit('custom-event', val);
    },
    onRefreshData(val) {
      this.$emit('refresh-data', val);
    },
  },
};
</script>

<style lang="less" scoped></style>
